import { createContext, useContext, useEffect } from "react";

// SYMIN is light-only. No dark mode, no toggle. `toggle` is a no-op kept for
// backward compatibility with any component still importing it.
const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.classList.remove("dark");
    localStorage.removeItem("sgex-theme");
  }, []);
  return (
    <ThemeContext.Provider value={{ theme: "light", toggle: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}
